import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useAuth } from 'react-oidc-context';
import { useStore } from '../../stores/store';
import { AppRoute } from '../../constants/route';
import { generateLocaleRoute } from '../../utils/uri/uri.utils';
import PageLoader from '../page-loader/page-loader.component';

export const getRouteWithParams = (
  path: string,
  searchParams: URLSearchParams
) => (searchParams.toString() ? `${path}?${searchParams.toString()}` : path);

interface Props {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<Props> = ({ children }) => {
  const {
    commonStore: { isGuestParcelCreation },
    userStore: { isLogoutRequested, user },
  } = useStore();
  const auth = useAuth();
  const navigate = useNavigate();

  const shouldRedirectToSignin =
    !auth.isAuthenticated &&
    !auth.isLoading &&
    !auth.activeNavigator &&
    !isLogoutRequested &&
    !isGuestParcelCreation;

  // Always leave a private route after authentication is lost. Using replace
  // prevents the failed private page from remaining in the browser history.
  useEffect(() => {
    if (!shouldRedirectToSignin) return;

    navigate(generateLocaleRoute(`${AppRoute.AUTH}/${AppRoute.SIGNIN}`), {
      replace: true,
    });
  }, [navigate, shouldRedirectToSignin]);

  if ((user && auth.isAuthenticated && !auth.error) || isGuestParcelCreation) {
    return children;
  }

  return <PageLoader />;
};

export default observer(PrivateRoute);
